"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var merge_1 = __importDefault(require("lodash/merge"));
var parseDataPaths_1 = require("../parseDataPaths");
var abab_1 = require("abab");
var InspectModule = /** @class */ (function () {
    function InspectModule() {
        this.inspect = {};
    }
    InspectModule.prototype.set = function (obj) {
        if (obj.inspect) {
            this.inspect = (0, merge_1.default)({}, this.inspect, obj.inspect);
        }
    };
    return InspectModule;
}());
var getPossibleDataPaths = function (deps) { return function (baseEntity, docB64) {
    var doc = new deps.DocxTemplater().loadZip(new deps.JSZIP((0, abab_1.atob)(docB64)));
    var inspectModule = new InspectModule();
    doc.attachModule(inspectModule);
    doc.compile();
    var postparsed = inspectModule.inspect.postparsed;
    return (0, parseDataPaths_1.parseDataPaths)(postparsed, deps.viewConfig, baseEntity);
}; };
exports.default = getPossibleDataPaths;
//# sourceMappingURL=extractDataPathsFromDocumentB64.js.map